import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { DireccionClienteEdit } from "./edit";
const EditModal = DireccionClienteEdit;
type Entity = models.DireccionClienteDTO;

export interface Props {
    idCliente: number;
    readonly?: boolean;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [
        botones,
        { title: "Descripción", cell: x => ({ data: x.Direccion.Descripcion }) },
        { title: "Contactos", cell: x => ({ data: x.Contactos.map(y => y.Nombre) }) },
    ];
}

/**
* Listado de DireccionClienteDTO
*/
class DireccionClienteDTOListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    idCliente = (x: Props) => x.idCliente;
    direccionesCliente = createSelectorRx(this.idCliente, idCliente => observeResource(resources.DireccionCliente.ObtenerDireccionesCliente, idCliente));

    private handleOnAgregar = async () => {
        const idCliente = this.idCliente(this.props);
        const result = await this.modals.showModal(EditModal, undefined, { idCliente: idCliente, Contactos: [] } as any);;
        if (result.result) {
            await resources.DireccionCliente.add(result.value);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            await resources.DireccionCliente.update(result.value);
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.Direccion.Descripcion);
        if (ok) {
            await resources.DireccionCliente.delete(item.IdRegistro);
        }
    }

    render() {
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar });
        const direcciones = this.direccionesCliente(this.props);

        return (
            <div>
                <kea.Panel title="Direcciones" style="info">
                    <div className="row">
                        <div className="col-md-12">
                            <h4>
                                <span>Direcciones</span>
                                <div className="pull-right">
                                    <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                                </div>
                            </h4>
                        </div>
                    </div>

                    <kea.Grid2 items={direcciones} columnas={cols} />
                    {this.modals.component}
                </kea.Panel>
            </div>
        );
    }
}
export const DireccionClienteDTOList = componentToRx(DireccionClienteDTOListNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/tabs/direcciones/list.tsx